var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as browserCrypto from '../crypto/browser';
import * as browserStorage from '../storage/browser';
export var DEFAULT_IMPLEMENTATION = {
    hash: {
        sha256: browserCrypto.sha256
    },
    aes: {
        encrypt: browserCrypto.encrypt,
        decrypt: browserCrypto.decrypt,
        genKeyStr: browserCrypto.genKeyStr,
        decryptGCM: browserCrypto.decryptGCM,
    },
    rsa: {
        verify: browserCrypto.rsaVerify
    },
    ed25519: {
        verify: browserCrypto.ed25519Verify
    },
    keystore: {
        publicReadKey: browserCrypto.ksPublicReadKey,
        publicWriteKey: browserCrypto.ksPublicWriteKey,
        decrypt: browserCrypto.ksDecrypt,
        sign: browserCrypto.ksSign,
        importSymmKey: browserCrypto.ksImportSymmKey,
        exportSymmKey: browserCrypto.ksExportSymmKey,
        keyExists: browserCrypto.ksKeyExists,
        getAlg: browserCrypto.ksGetAlg,
        clear: browserCrypto.ksClear,
    },
    storage: {
        getItem: browserStorage.getItem,
        setItem: browserStorage.setItem,
        removeItem: browserStorage.removeItem,
        clear: browserStorage.clear,
    }
};
export var impl = DEFAULT_IMPLEMENTATION;
export var setDependencies = function (fns) {
    impl = {
        hash: merge(impl.hash, fns.hash),
        aes: merge(impl.aes, fns.aes),
        rsa: merge(impl.rsa, fns.rsa),
        ed25519: merge(impl.ed25519, fns.ed25519),
        keystore: merge(impl.keystore, fns.keystore),
        storage: merge(impl.storage, fns.storage),
    };
    return impl;
};
var merge = function (first, second) {
    return __assign(__assign({}, first), (second || {}));
};
//# sourceMappingURL=dependencies.js.map